import { useState } from "react";
import { loginUser, registerUser, saveAuth } from "../services/api";

export default function AuthForm({ onAuthed }) {
  const [mode, setMode] = useState("login"); // "login" | "register"
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const payload =
        mode === "register"
          ? { name, email, password }
          : { email, password };

      const res = mode === "register"
        ? await registerUser(payload)
        : await loginUser(payload);

      saveAuth(res);
      onAuthed(res.user); // tell App we are logged in
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <h2 style={{ marginBottom: 8 }}>
        {mode === "login" ? "Login" : "Register"}
      </h2>

      <form onSubmit={submit}>
        {mode === "register" && (
          <input
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        )}

        <input
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
        />

        <input
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "..." : mode === "login" ? "Login" : "Register"}
        </button>

        <button
          type="button"
          onClick={() => setMode(mode === "login" ? "register" : "login")}
          style={{ marginLeft: 12, width: "auto", padding: "12px 16px" }}
        >
          Switch to {mode === "login" ? "Register" : "Login"}
        </button>
      </form>

      {error && (
        <p style={{ marginTop: 12, color: "#ff4d6d" }}>
          {error}
        </p>
      )}
    </div>
  );
}